import { POPOUP_HIDE, POPOUP_SHOW } from './../actions';

const initialState = {
	list: []
};

export default function survey(state = initialState, action) {
	const { type, payload } = action;
	switch (type) {
		case POPOUP_HIDE: {
			return { ...state, list: [] };
		}
		case POPOUP_SHOW: {
			const { data } = payload;
			return { ...state, list: [{ path: 'Popup/Popup', id: 0, type: data }] };
		}
		default: return state
	}
}


// WEBPACK FOOTER //
// ./src/reducers/popup.js